import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/artem_bilo.jpeg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonArtemBiloshchytskyi = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Белощицкий Артем Андреевич</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Secondary specialized education as a software developer, currently finishing Bachelor degree in Software Engineering
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=60370349800'}>
                            <MyText><LinkOutlined /> Scopus (h=1)</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0009-0000-5571-4412'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Astana IT University», программист, НИЦ «Industry 4.0»</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Программист</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка дополнений для веб-платформы и её поддержка;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка веб-платформы для опросника по семинарам;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка веб-платформы для добавления и управления семинарами.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Окончил техническое и профессиональное образование с отличием по специальности «Разработчик ПО». Full-Stack-разработка сайтов и веб-приложений: ReactJS, NodeJS, Django, опыт работы с GIS.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «ИАС трансграничных водных ресурсов» (2024-2026), программист.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Omarova, Neftissov, Borsikbayeva, Kazambayev, Biloshchytskyi, Aubakirova. Numerical Simulation of Water Flow Through a Porous Medium: Verification by the Lin 1999 Experiment. Scientific Journal of Astana IT University, 23, 2025.
                </MyText>
            </Flex>
        </Flex>
    );
};
